// speak - voice-over ringan pakai Web Speech API bawaan browser (tanpa file
// audio/CDN — cocok utk kiosk yang mungkin tak selalu online). Dipakai kiosk
// absensi wajah utk mengumumkan hasil scan secara lisan.
export function speak(text, lang = "id-ID") {
  if (typeof window === "undefined" || !("speechSynthesis" in window)) return;
  try {
    // Batalkan ucapan yang mungkin masih berjalan (mis. dari scan sebelumnya
    // yang belum selesai diucapkan) supaya tak menumpuk/tumpang tindih.
    window.speechSynthesis.cancel();
    const utter = new SpeechSynthesisUtterance(text);
    utter.lang = lang;
    utter.rate = 1;
    utter.pitch = 1;
    window.speechSynthesis.speak(utter);
  } catch (e) {
    // Voice-over murni pemanis - kegagalan di sini tak boleh mengganggu alur absen.
  }
}
